import { Component, inject, OnInit } from '@angular/core';
import { Api } from '../../services/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Mdlfilterectivities } from '../mdl-filter-activities/mdl-filter-activities';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-activities',
  imports: [CommonModule, FormsModule, DatePipe],
  templateUrl: './activities.html',
  styleUrl: './activities.css'
})
export class Activities implements OnInit {
  private api = inject(Api);
  expanded: { [id: string]: boolean } = {};
  sectionExpanded = {
  pendientes: true,
  vencidas: true,
  realizadas: true
};

  tiposTarea = [
    {
      valor: 'Tarea',
      icono: 'assets/svg/task-icon-orange.svg',
    },
    {
      valor: 'Evento',
      icono: 'assets/svg/new-event-icon.svg',
    },
    {
      valor: 'Correo',
      icono: 'assets/svg/new-email-icon.svg',
    },
    {
      valor: 'Llamada',
      icono: 'assets/svg/call-icon.svg',
    },
  ];


  tasks: any[] = [];
  entidad_id: string = '';

  t_pendientes: any[] = [];
  t_realizadas: any[] = [];
  t_vencidas: any[] = [];

  
  readonly dialog = inject(MatDialog);

  constructor(
    private router: Router,
    private ActivatedRoute: ActivatedRoute
  ) { 
      this.ActivatedRoute.params.subscribe(params => {
      this.entidad_id = params['id'];
    });
  }

  ngOnInit(): void {
    this.loadTasks();
  }

  loadTasks() {
    this.api.showLoading();
    this.api.getEntityTasks({entidad_id: this.entidad_id}).subscribe({
      next: (response: any) => {
        console.log('Tasks response:', response);
        this.tasks = response.tareas || [];
        this.tasks.push(...response.eventos || []);
        this.t_pendientes = this.tasks.filter(t => t.estado === 'Pendiente');
        this.t_realizadas = this.tasks.filter(t => t.estado === 'Realizada');
        this.t_vencidas = this.tasks.filter(t => t.estado === 'Vencida');

        console.log('Tareas pendientes:', this.t_pendientes);
        this.api.hideLoading();
      },
      error: (error) => {
        console.error('Error fetching tasks:', error);
        this.api.hideLoading();
      }
    });
  }

  setIconoTipo(tipo: string): string {
    const tipoEncontrado = this.tiposTarea.find(t => t.valor === tipo);
    return tipoEncontrado ? tipoEncontrado.icono : 'assets/svg/task-icon-orange.svg';
  }


    openNewfilterActivities(): void {
      this.dialog.open(Mdlfilterectivities, {
        minWidth: '650px',
        maxHeight: '900px',
        panelClass: 'mat-dlg-class'
      });
    }

    reload(){
      window.location.reload();

    }

    toggle(taskId: string) {
      this.expanded[taskId] = !this.expanded[taskId];
    }
    toggleSection(section: 'pendientes' | 'vencidas' | 'realizadas') {
      this.sectionExpanded[section] = !this.sectionExpanded[section];
    }
}
